import { t } from "@lingui/macro";
import _ from "lodash";

export const GetTransportNameFromCode = (code: string) => {
  switch (code) {
    case "CART":
      return t`Cart`;
    case "PULL_CART":
      return t`Pull Cart`;
    case "WALK":
      return t`Walk`;
    case "CADDIE":
      return t`Caddie`;
    case "CADDIE_CART":
      return t`Caddie & Cart`;
    default:
      return _.startCase(_.toLower(code));
  }
};

export type TransportAccessibility =
  | "ACCESSIBLE"
  | "INACCESSIBLE"
  | "ALL_ACCESSIBLE";

export const getTransportAccessibility = (
  transportMemberGroupIds: string[],
  memberMemberGroupIds: string[] | undefined
) => {
  const hasMemberGroupMatch =
    transportMemberGroupIds?.filter((value) =>
      memberMemberGroupIds?.includes(value)
    ).length > 0;
  let accessibility: TransportAccessibility = "ALL_ACCESSIBLE";

  if (hasMemberGroupMatch) {
    accessibility = "ACCESSIBLE";
  } else if (transportMemberGroupIds.length > 0 && !!memberMemberGroupIds) {
    accessibility = "INACCESSIBLE";
  }
  return accessibility;
};
